const decisions = {
  pending: {
    label: "En attente du retour client",
    style: "bg-amber-50 text-amber-800 border-amber-200",
  },
  accepted: {
    label: "Candidature acceptée",
    style: "bg-emerald-50 text-emerald-800 border-emerald-200",
  },
  rejected: {
    label: "Candidature refusée",
    style: "bg-rose-50 text-rose-800 border-rose-200",
  },
};

export default function InterviewClientFeedback({ feedback }) {
  const decision = decisions[feedback?.status] || decisions.pending;
  const rating = feedback?.rating;
  const validRating =
    typeof rating === "number" &&
    Number.isInteger(rating) &&
    rating >= 1 &&
    rating <= 5;
  const respondedAt = feedback?.respondedAt
    ? new Date(feedback.respondedAt)
    : null;
  return (
    <section
      aria-label="Retour du client"
      className="mt-3 border-t border-slate-100 pt-2"
    >
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs">
        <h4 className="font-medium text-slate-500">Retour du client</h4>
        <span
          className={`rounded-full border px-2 py-0.5 font-semibold ${decision.style}`}
        >
          {decision.label}
        </span>
        {validRating && (
          <span className="text-slate-700">
            <span className="mr-1 text-slate-500">Note du client</span>
            {rating} / 5
          </span>
        )}
        {respondedAt && !Number.isNaN(respondedAt.getTime()) && (
          <span className="text-slate-500">
            <span className="mr-1">Réponse reçue le</span>
            {respondedAt.toLocaleString("fr-FR", { timeZone: "Europe/Paris", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })}
          </span>
        )}
      </div>
      {feedback?.comment && (
        <p className="mt-2 whitespace-pre-wrap break-words text-sm text-slate-700">
          <span className="mr-2 text-xs font-medium text-slate-500">
            Commentaire du client
          </span>
          {feedback.comment}
        </p>
      )}
    </section>
  );
}
